import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LogoSection } from './logo-section';
import { SearchBox } from './search-box';

export function DesktopLogoAndSearch({
  showSearchBar = true,
  renderLogo = undefined,
  useGlassTheme = false,
  withAiLink = true,
  use2027Theme = false,
}) {
  return (
    <div
      className={classnames(
        'd-flex align-items-center w-sm-auto w-100 flex-column flex-sm-row flex-md-row justify-content-center',
        {
          'flex-basis-100': showSearchBar,
        }
      )}
    >
      <LogoSection renderLogo={renderLogo} useGlassTheme={useGlassTheme} use2027Theme={use2027Theme} />
      {showSearchBar && <SearchBox isMobile={false} withAiLink={withAiLink} use2027Theme={use2027Theme} />}
    </div>
  );
}

DesktopLogoAndSearch.propTypes = {
  showSearchBar: PropTypes.bool,
  renderLogo: PropTypes.func,
  useGlassTheme: PropTypes.bool,
  withAiLink: PropTypes.bool,
  use2027Theme: PropTypes.bool,
};
